import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UaenamePipe } from 'src/app/core/services/uaename.pipe';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { HttpResponse } from '@angular/common/http';

interface Country {
  code: string;
  name: string;
  flag: string;
}

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css', '../../shared/styles/common.css'],
    standalone: false
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  hidePassword: boolean = false;
  hideConfirmPassword: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';
  //countries: Country[] = [];
  // countries: { [key: string]: any } = {
  //   "Argentina": "ar",
  //   "Australia": "au",
  //   "Austria": "at",
  //   "Belgium": "be",
  //   "Bosnia": "ba",
  //   "Brazil": "br",
  //   "Bulgaria": "bg",
  //   "Canada": "ca",
  //   "Chile": "cl",
  //   "China": "cn",
  //   "Croatia": "hr",
  //   "Czech Republic": "cz",
  //   "Denmark": "dk",
  //   "Estonia": "ee",
  //   "Finland": "fi",
  //   "France": "fr",
  //   "Germany": "de",
  //   "Herzegovina": "ba", // Bosnia and Herzegovina use the same code
  //   "Iceland": "is",
  //   "India": "in",
  //   "Indonesia": "id",
  //   "Israel": "il",
  //   "Italy": "it",
  //   "Latvia": "lv",
  //   "Lithuania": "lt",
  //   "Macedonia": "mk",
  //   "Malaysia": "my",
  //   "Mexico": "mx",
  //   "Moldova": "md",
  //   "Montenegro": "me",
  //   "Netherlands": "nl",
  //   "New Zealand": "nz",
  //   "Norway": "no",
  //   "Poland": "pl",
  //   "Portugal": "pt",
  //   "Romania": "ro",
  //   "Serbia": "rs",
  //   "Singapore": "sg",
  //   "Slovakia": "sk",
  //   "Slovenia": "si",
  //   "South Africa": "za",
  //   "South Korea": "kr",
  //   "Spain": "es",
  //   "Sweden": "se",
  //   "Switzerland": "ch",
  //   "Turkey": "tr",
  //   "Ukraine": "ua",
  //   "United Arab Emirates": "ae",
  //   "United Kingdom": "gb",
  //   "United States": "us",
  //   "USA": "us"
  // };

 countries: any[] = [];
  countryName = 'select an option';
  submitted = false;
  password_status = "fa fa-eye-slash";
  hide = true;
  confirm_password_status = "fa fa-eye-slash";
  confirm_hide = true;

  message: string = '';
  subscription: any;
  countryObj:any = {
      "Argentina": "ar",
      "Australia": "au",
      "Austria": "at",
      "Belgium": "be",
      "Bosnia": "ba",
      "Brazil": "br",
      "Bulgaria": "bg",
      "Canada": "ca",
      "Chile": "cl",
      "China": "cn",
      "Croatia": "hr",
      "Czech Republic": "cz",
      "Denmark": "dk",
      "Estonia": "ee",
      "Finland": "fi",
      "France": "fr",
      // "Germany": "de",
      "Herzegovina": "ba",
      "Iceland": "is",
      "India": "in",
      "Indonesia": "id",
      "Israel": "il",
      "Italy": "it",
      "Latvia": "lv",
      "Lithuania": "lt",
      "Macedonia": "mk",
      "Malaysia": "my",
      "Mexico": "mx",
      "Moldova": "md",
      "Montenegro": "me",
      "Netherlands": "nl",
      "New Zealand": "nz",
      "Norway": "no",
      "Poland": "pl",
      "Portugal": "pt",
      "Romania": "ro",
      "Serbia": "rs",
      "Singapore": "sg",
      "Slovakia": "sk",
      "Slovenia": "si",
      "South Africa": "za",
      "South Korea": "kr",
      "Spain": "es",
      "Sweden": "se",
      "Switzerland": "ch",
      "Turkey": "tr",
      "Ukraine": "ua",
      "United Arab Emirates": "ae",
      "United Kingdom": "gb",
      "USA": "us"
  };
  passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,15}$/;
  passwordError: string = '';

  constructor(
    private fb: FormBuilder, private authService: AuthService,
    private router: Router, private toastr: ToastrService,
    private snackBar: MatSnackBar, private data: DataService
  ) {
    this.registerForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8),
      Validators.maxLength(15),
      Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      country: ['', [Validators.required]],
      //acceptTerms: [false, [Validators.requiredTrue]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit() {
    //this.loadCountries();

    // Trigger validation when password changes
    this.registerForm.get('password')?.valueChanges.subscribe(() => {
      this.registerForm.get('confirmPassword')?.updateValueAndValidity();
    });

    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard']);
    }

    this.authService.getCountries().subscribe((resp: any) => {
      this.countries = resp.data.countries;
     // this.countries.shift();
      this.countries = Object.entries(this.countryObj);
    })
  }

  // getFlagEmoji(countryCode: string): string {
  //   return countryCode
  //     .toUpperCase()
  //     .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0)));
  // }

  // private loadCountries(): void {
  //   this.countries = [
  //     { code: 'US', name: 'United States', flag: 'usa.png' },
  //     { code: 'UK', name: 'United Kingdom', flag: 'uk.png' },
  //   ];
  // }

  checkPassword(event: Event) {
  const input = (event.target as HTMLInputElement).value;

  if (!this.passwordPattern.test(input)) {
    this.passwordError = "Password must be 8-15 characters with at least 1 digit, 1 uppercase, 1 lowercase, and 1 special character";
  } else {
    this.passwordError = '';
  }
}

  onSubmit() {
    if (this.registerForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';

      const userData = {
        firstName: this.registerForm.get('firstName')?.value,
        lastName: this.registerForm.get('lastName')?.value,
        email: this.registerForm.get('email')?.value,
        password: this.registerForm.get('password')?.value,
        country: this.registerForm.get('country')?.value
      };

      this.authService.register(userData).subscribe({
        next: (response: any) => {
          this.snackBar.open('Registration successful! Verify your email.', 'Close', { duration: 3000 });
          this.router.navigate(['/verify-email'], { 
            queryParams: { 
              email: userData.email 
            }
          });
        },
        // error: (error) => {
        //   this.isLoading = false;
        //   this.errorMessage = error.error?.message || 'Registration failed. Please try again.';
        //   this.snackBar.open(this.errorMessage, 'Close', { duration: 3000 });
        // }
        error: (error) => {
          console.log('err',error)
          this.isLoading = false;

          const backendErrors = error.error?.errors;
          if (Array.isArray(backendErrors)) {
            backendErrors.forEach((err: { field: string, msg: string }) => {
              const field = this.registerForm.get(err.field);
              if (field) {
                field.setErrors({ serverError: err.msg });
              }
            });
          }
          this.errorMessage = (error.error?.message || error.error?.msg) || 'Registration failed. Please try again.';
          this.snackBar.open(this.errorMessage, 'Close', { duration: 3000 });
        }
      });
    } else {
      this.markFormGroupTouched(this.registerForm);
    }
  }

  onSignUpButtonClicked(firstName: string, lastname: string, country: string, email: string, password: string, ConfirmPassword: string) {
    this.submitted = true;
      // Mark all fields as touched so errors appear
      Object.values(this.registerForm.controls).forEach(control => {
        control.markAsTouched();
      });

    if (this.registerForm.invalid) {
        return;
    }
    let countryName = this.registerForm.get('country')?.value
    this.data.changeMessage(email);
    ////console.log(this.message);
    //debugger;
    // this.authService.signUp(firstName, lastname, countryName, email, password).subscribe((res: HttpResponse<any>) => {
    //   if(!res.body.error ) {
    //     this.router.navigate(['/mail-verification']);
    //    // this.toastr.success(res.body.msg, "Success!");
    //   } 
    //   else {
    //     if(res.body.msg.email){
    //       this.toastr.error(res.body.msg.email, "Error!");
    //     } else {
    //       this.toastr.error(res.body.msg, "Error!");
    //     }
    //   }
    // });
   
    // this.authService.signUp(firstName, lastname, countryName, email, password).subscribe({
    //   next: (res: HttpResponse<any>) => {
    //     if (!res.body.error) {
    //       this.router.navigate(['/mail-verification']);
    //     } else {
    //       // Show backend message if email already exists
    //       this.toastr.error(res.body.msg || 'Something went wrong', 'Error!');
    //     }
    //   },
    //   error: (err) => {
    //     // Handles 409 or other unexpected errors
    //     if (err.status === 409 && err.error?.msg) {
    //       this.toastr.error(err.error.msg);

    //       // OPTIONAL: Attach it to the email form control
    //       this.registerForm.get('email')?.setErrors({ serverError: err.error.msg });
    //     } else {
    //       this.toastr.error('Registration failed. Please try again.', 'Error!');
    //     }
    //   }
    // });

    this.authService.signUp(firstName, lastname, countryName, email, password).subscribe({
      next: (res: any) => {
        if (!res.error) {
          this.router.navigate(['/mail-verification']);
        } else {
          const message = res.errors?.[0]?.msg || 'Something went wrong';
          this.toastr.error(message, 'Error!');
        }
      },
      error: (err) => {
        const message = err.error?.errors?.[0]?.msg || 'Registration failed';
        this.toastr.error(message, 'Error!');
        this.registerForm.get('email')?.setErrors({ serverError: message });
      }
    });

  }

  private passwordMatchValidator(g: FormGroup) {
    const password = g.get('password')?.value;
    const confirmPassword = g.get('confirmPassword')?.value;
    
    // ✅ Only check if both fields have values
    if (!password || !confirmPassword) {
      return null; // Don't show mismatch error until both fields have input
    }
    
    return password === confirmPassword ? null : { mismatch: true };
  }
  

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
    
  restricttextSpace(event: any) {
		let inputValue: string = event.target.value;
		inputValue = inputValue.replace(/^\s+/, '');
		inputValue = inputValue.replace(/\s{2,}/g, ' ');
		event.target.value = inputValue;
		return;
	}
}